import { AnimatePresence, motion } from "framer-motion";

const RightQuestionsSidebar = ({ state, dispatch, setShow, show }) => {
  return (
    <AnimatePresence mode="wait">
      {show && (
        <div
          onClick={() => setShow(false)}
          className="fixed top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 flex items-center justify-center px-5 w-full h-screen bg-black/50 backdrop-blur-lg z-[10000]"
        >
          <motion.div
            key="modal"
            initial={{ opacity: 0, y: 20, scale: 0.8 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            exit={{ opacity: 0, y: 20, scale: 0.8 }}
            transition={{ duration: 0.2 }}
            onClick={(e) => e.stopPropagation()}
            className="bg-white rounded-lg p-6 max-w-4xl w-full max-h-[90vh] overflow-y-auto"
          >
            {/* Header */}
            <div className="flex justify-between items-center mb-4">
              <h2 className="text-3xl text-black font-semibold">
                Question Navigator - {state.quizInfo.title}
              </h2>
              <button
                onClick={() => setShow(false)}
                className="text-gray-500 hover:text-gray-700"
              >
                <svg
                  className="w-6 h-6"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M6 18L18 6M6 6l12 12"
                  />
                </svg>
              </button>
            </div>

            {/* Grid of question buttons */}
            <div className="grid grid-cols-6 gap-3 mb-4">
              {state.questions.map((q, i) => {
                const isCurrent = i === state.currentQuestionIndex;

                const answered = state.questions.find(
                  (ans) => ans.id === q.id
                ).userAnswer;
                const isAnswered =
                  answered &&
                  answered.order !== "unanswered" &&
                  answered.order !== "E" &&
                  answered.order !== "" &&
                  answered.order != null;
                const isFlagged = q.flagged;

                const baseClasses =
                  "h-16 w-16 rounded-md flex items-center justify-center font-medium transition-colors";

                let bg = "bg-gray-100 border border-gray-300";
                if (isAnswered && isFlagged) {
                  bg =
                    "bg-green-100 border border-green-400 relative before:absolute before:top-1 before:left-1 before:w-3 before:h-3 before:bg-yellow-400 before:rotate-45 before:clip-path-triangle";
                } else if (isAnswered) {
                  bg = "bg-green-100 border border-green-400";
                } else if (isFlagged) {
                  bg = "bg-yellow-100 border-2 border-yellow-400";
                }

                const ring = isCurrent
                  ? "ring-2 ring-blue-500 ring-offset-2"
                  : "";

                return (
                  <button
                    key={i}
                    onClick={() => {
                      dispatch({
                        type: "setCurrentQuestionIndex",
                        payload: q.id,
                      });
                      setShow(false);
                    }}
                    className={`${baseClasses} ${bg} ${ring} text-black hover:bg-blue-100 hover:border-blue-400 relative`}
                  >
                    {i + 1}
                  </button>
                );
              })}
            </div>

            {/* Legend */}
            <div className="flex gap-4">
              <div className="flex items-center gap-2">
                <div className="h-8 w-8 bg-green-100 border border-green-400"></div>
                <span className="text-xl text-black">Answered</span>
              </div>
              <div className="flex items-center gap-2">
                <div className="h-8 w-8 bg-yellow-100 border-2 border-yellow-400"></div>
                <span className="text-xl text-black">Flagged</span>
              </div>
              <div className="flex items-center gap-2">
                <div className="h-8 w-8 bg-gray-100 border border-gray-300"></div>
                <span className="text-xl text-black ">Unanswered</span>
              </div>
            </div>
          </motion.div>
        </div>
      )}
    </AnimatePresence>
  );
};

export default RightQuestionsSidebar;
